import Tabs from "@components/Tabs/Tabs";
import { ByoAnalyticType, useByoDataContext } from "@pages/Byo/ByoContext";

const byoTopChartItems = [
    {
        name: 'Penetration',
        id: ByoAnalyticType.Penetration,
        tooltip: '% of restaurants',
    },
    {
        name: 'Incidence',
        id: ByoAnalyticType.Incidence,
        tooltip: '% of items',
    },
    {
        name: 'Price',
        id: ByoAnalyticType.Price,
        tooltip: 'Median price',
    },
];

const AnalyticsTypeTabs = () => {
    const { activeAnalyticsType, setActiveAnalyticsType } = useByoDataContext();

    return (
        <Tabs
            data={byoTopChartItems}
            handleClick={(id) => setActiveAnalyticsType(id as ByoAnalyticType)}
            activeItemId={activeAnalyticsType}
        />
    );
};

export default AnalyticsTypeTabs;